<template>
  <div class="rates-additional-info">
    <div v-for="(r, i) in row" :key="i">
      <div v-if="r.rateData && r.rateData.rate && r.rateData.rate.validity && r.rateData.rate.validity.from">
        <span class="font-weight-bold">From:</span>
        {{ r.rateData.rate.validity.from }}
      </div>
      <div v-if="r.rateData && r.rateData.rate && r.rateData.rate.validity && r.rateData.rate.validity.to">
        <span class="font-weight-bold">To:</span>
        {{ r.rateData.rate.validity.to }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalcRatesTableCellValidity',
  props: {
    row: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellValidity.vue